import { render, staticRenderFns } from "./VerticalProduct.vue?vue&type=template&id=7e239e14&scoped=true"
import script from "./VerticalProduct.vue?vue&type=script&lang=js"
export * from "./VerticalProduct.vue?vue&type=script&lang=js"
import style0 from "./VerticalProduct.vue?vue&type=style&index=0&id=7e239e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e239e14",
  null
  
)

export default component.exports